/* CBDLegalPT · carrossel de variedades do hero (sem bibliotecas) */
(function () {
  'use strict';
  if (window.CbdlCoverflow) return;

  function CbdlCoverflow(root) {
    this.root = root;
    this.cards = Array.prototype.slice.call(root.querySelectorAll('.cbdl-cf__card'));
    this.panels = Array.prototype.slice.call(root.querySelectorAll('.cbdl-cfi__panel'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('[data-cf-dot]'));
    this.live = root.querySelector('[data-cf-live]');
    this.toggleBtn = root.querySelector('[data-cf-toggle]');
    this.n = this.cards.length;
    this.i = 0;
    this.ms = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    this.mq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    this.wantsAuto = root.getAttribute('data-autoplay') === 'true';
    this.userPaused = false;
    this.hovering = false;
    this.focused = false;
    this.inView = true;
    this.timer = null;
    if (this.n < 2) return;
    this.bind();
    this.go(0, false);
    this.syncToggle();
    this.schedule();
    root.classList.add('is-ready');
  }

  CbdlCoverflow.prototype.autoOn = function () {
    return this.wantsAuto && !this.mq.matches && !this.userPaused;
  };

  CbdlCoverflow.prototype.offset = function (j) {
    var n = this.n, o = j - this.i, half = Math.floor(n / 2);
    if (o > half) o -= n;
    if (o < -half || (n % 2 === 0 && o === -half)) o += n;
    return Math.max(-3, Math.min(3, o));
  };

  CbdlCoverflow.prototype.go = function (k, announce) {
    var self = this, n = this.n;
    this.i = ((k % n) + n) % n;
    this.cards.forEach(function (c, j) {
      var o = self.offset(j);
      c.setAttribute('data-pos', String(o));
      c.tabIndex = o === 0 ? 0 : -1;
      if (o === 0) c.setAttribute('aria-current', 'true'); else c.removeAttribute('aria-current');
      if (Math.abs(o) > 2) c.setAttribute('aria-hidden', 'true'); else c.removeAttribute('aria-hidden');
      var img = c.querySelector('img[loading="lazy"]');
      if (img && Math.abs(o) <= 2) img.loading = 'eager';
    });
    this.panels.forEach(function (p) {
      var on = parseInt(p.getAttribute('data-i'), 10) === self.i;
      p.classList.toggle('is-on', on);
      if (on) { p.removeAttribute('aria-hidden'); p.removeAttribute('inert'); }
      else { p.setAttribute('aria-hidden', 'true'); p.setAttribute('inert', ''); }
    });
    this.dots.forEach(function (d, j) {
      if (j === self.i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
    });
    if (this.live) {
      this.live.setAttribute('aria-live', this.running() ? 'off' : 'polite');
      if (announce) {
        var t = this.panels[this.i] && this.panels[this.i].querySelector('.cbdl-cfi__t');
        this.live.textContent = (t ? t.textContent.trim() : '') + ' (' + (this.i + 1) + ' de ' + n + ')';
      }
    }
  };

  CbdlCoverflow.prototype.running = function () {
    return this.autoOn() && !this.hovering && !this.focused && this.inView && !document.hidden;
  };

  CbdlCoverflow.prototype.schedule = function () {
    var self = this;
    clearTimeout(this.timer);
    this.timer = null;
    if (this.live) this.live.setAttribute('aria-live', this.running() ? 'off' : 'polite');
    if (!this.running()) return;
    this.timer = setTimeout(function () { self.go(self.i + 1, false); self.schedule(); }, this.ms);
  };

  CbdlCoverflow.prototype.user = function (k) {
    this.go(k, true);
    this.schedule();
  };

  CbdlCoverflow.prototype.syncToggle = function () {
    var b = this.toggleBtn;
    if (!b) return;
    var hidden = !this.wantsAuto || this.mq.matches;
    b.hidden = hidden;
    var paused = this.userPaused;
    b.setAttribute('aria-pressed', paused ? 'true' : 'false');
    b.setAttribute('aria-label', paused ? 'Retomar rotação automática' : 'Pausar rotação automática');
    b.classList.toggle('is-paused', paused);
  };

  CbdlCoverflow.prototype.bind = function () {
    var self = this, root = this.root;
    var prev = root.querySelector('[data-cf-prev]'), next = root.querySelector('[data-cf-next]');
    if (prev) prev.addEventListener('click', function () { self.user(self.i - 1); });
    if (next) next.addEventListener('click', function () { self.user(self.i + 1); });
    this.dots.forEach(function (d, j) { d.addEventListener('click', function () { self.user(j); }); });
    if (this.toggleBtn) this.toggleBtn.addEventListener('click', function () {
      self.userPaused = !self.userPaused; self.syncToggle(); self.schedule();
    });

    this.cards.forEach(function (c, j) {
      c.addEventListener('click', function (e) {
        if (self.swiped) { e.preventDefault(); self.swiped = false; return; }
        if (j !== self.i) { e.preventDefault(); self.user(j); }
      });
    });

    root.addEventListener('keydown', function (e) {
      if (e.target.closest && e.target.closest('.cbdl-cfi')) return;
      var k = e.key;
      if (k === 'ArrowLeft') { e.preventDefault(); self.user(self.i - 1); }
      else if (k === 'ArrowRight') { e.preventDefault(); self.user(self.i + 1); }
      else if (k === 'Home') { e.preventDefault(); self.user(0); }
      else if (k === 'End') { e.preventDefault(); self.user(self.n - 1); }
    });

    root.addEventListener('mouseenter', function () { self.hovering = true; self.schedule(); });
    root.addEventListener('mouseleave', function () { self.hovering = false; self.schedule(); });
    root.addEventListener('focusin', function () { self.focused = true; self.schedule(); });
    root.addEventListener('focusout', function (e) {
      if (!e.relatedTarget || !root.contains(e.relatedTarget)) { self.focused = false; self.schedule(); }
    });
    document.addEventListener('visibilitychange', function () { self.schedule(); });
    var onMq = function () { self.syncToggle(); self.schedule(); };
    if (this.mq.addEventListener) this.mq.addEventListener('change', onMq);
    else if (this.mq.addListener) this.mq.addListener(onMq);

    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        self.inView = es[0].isIntersecting; self.schedule();
      }, { threshold: 0.25 }).observe(root);
    }

    /* swipe (toque e caneta); o rato usa as setas e os cartões */
    var stage = root.querySelector('.cbdl-cf__stage'), sx = 0, sy = 0, tracking = false;
    if (stage) {
      stage.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') return;
        tracking = true; sx = e.clientX; sy = e.clientY;
      }, { passive: true });
      stage.addEventListener('pointerup', function (e) {
        if (!tracking) return; tracking = false;
        var dx = e.clientX - sx, dy = e.clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) {
          self.swiped = true;
          setTimeout(function () { self.swiped = false; }, 350);
          self.user(dx < 0 ? self.i + 1 : self.i - 1);
        }
      });
      stage.addEventListener('pointercancel', function () { tracking = false; });
    }

    /* editor de temas: ao selecionar um bloco, mostra essa variedade */
    document.addEventListener('shopify:block:select', function (e) {
      var idx = self.cards.indexOf(e.target);
      if (idx > -1) { self.userPaused = true; self.syncToggle(); self.user(idx); }
    });
  };

  window.CbdlCoverflow = CbdlCoverflow;
  function init(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-cbdl-cf]'), function (el) {
      if (!el.__cbdlCf) el.__cbdlCf = new CbdlCoverflow(el);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
